import React from 'react';
import Logo from '../components/Logo';

export default function LoadingPage({ brand  }) {

  return (
    <div className="min-h-screen flex items-center justify-center relative overflow-hidden" style={{ background: '#0d1b2e' }}>

      {/* Background blobs */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 left-0 w-96 h-96 rounded-full animate-pulse" style={{ background: 'rgba(232,69,69,0.12)', filter: 'blur(80px)' }}></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 rounded-full animate-pulse" style={{ background: 'rgba(255,123,71,0.12)', filter: 'blur(80px)', animationDelay: '1s' }}></div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-64 h-64 rounded-full" style={{ background: 'rgba(232,69,69,0.06)', filter: 'blur(60px)' }}></div>
      </div>

      <div className="relative z-10 text-center">
        <div className="relative inline-block mb-8">
          <div className="transform scale-150 animate-pulsate">
            <Logo logoUrl={brand?.logo_url} variant="loading" />

          </div>
          <div className="absolute inset-0 overflow-hidden rounded-lg">
            <div className="absolute inset-0 -left-full animate-swoosh skew-x-12" style={{ background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.15), transparent)' }}></div>
          </div>
        </div>

        <h2 className="text-2xl md:text-3xl font-bold text-white mb-4 animate-pulse">
          Nous recherchons les meilleures offres pour vous...
        </h2>

        <div className="flex items-center justify-center gap-2 mt-6">
          <div className="w-3 h-3 rounded-full animate-bounce" style={{ background: '#e84545', animationDelay: '0s' }}></div>
          <div className="w-3 h-3 rounded-full animate-bounce" style={{ background: '#FF7B47', animationDelay: '0.2s' }}></div>
          <div className="w-3 h-3 rounded-full animate-bounce" style={{ background: '#e84545', animationDelay: '0.4s' }}></div>
        </div>

        <div className="mt-8 w-64 mx-auto">
          <div className="h-2 rounded-full overflow-hidden" style={{ background: 'rgba(255,255,255,0.1)' }}>
            <div className="h-full rounded-full animate-progress" style={{ background: 'linear-gradient(90deg, #e84545, #FF7B47)' }}></div>
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes swoosh {
          0% { left: -100%; }
          100% { left: 200%; }
        }
        @keyframes progress {
          0% { width: 0%; }
          50% { width: 70%; }
          100% { width: 100%; }
        }
        @keyframes pulsate {
          0%, 100% { transform: scale(1.5); }
          50% { transform: scale(1.7); }
        }
        .animate-swoosh { animation: swoosh 2s ease-in-out infinite; }
        .animate-progress { animation: progress 2s ease-in-out infinite; }
        .animate-pulsate { animation: pulsate 1.5s ease-in-out infinite; }
      `}</style>
    </div>
  );
}